import { useMemo } from 'react';

import type { InboxEntry } from '@this+that/models';

import { useDoBoxRunViewStore } from '../../store/DoBoxRunView';
import { applyPresentedStatusOverrides } from '../../utils/delegation/resolvePresentedRunStatus';

export function useSettledInboxEntry(inboxEntry: InboxEntry): InboxEntry;
export function useSettledInboxEntry(
  inboxEntry: InboxEntry | undefined,
): InboxEntry | undefined;

/** The entry with every run's status settled by what the run screen published, so the header
 *  chip, the card bands and the notices never contradict the run card. */
export function useSettledInboxEntry(
  inboxEntry: InboxEntry | undefined,
): InboxEntry | undefined {
  const overrides = useDoBoxRunViewStore((s) => s.presentedStatusByEntryId);
  return useMemo(
    () =>
      inboxEntry
        ? applyPresentedStatusOverrides(inboxEntry, overrides)
        : undefined,
    [inboxEntry, overrides],
  );
}
